import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const IMG_HERO_BG = '/hero-canne.png';
const IMG_CANNE = '/cat-canne-prodotti.png';
const IMG_MONOFILI = '/cat-monofili-prodotti.png';
const IMG_ACCESSORI = '/cat-accessori-prodotti.jpg';

const CATS = [
  { title: 'Canne\nda pesca', text: 'Per ogni situazione di pesca, per ogni stile e preda, Falcon ha la canna adatta a te.', img: IMG_CANNE, btn: 'Scopri le canne da pesca', slug: 'canne-da-pesca', imgLeft: true, imgFit: 'contain' },
  { title: 'Line', text: "Ogni pescatore coltiva la propria passione al meglio, Falcon con i suoi 30 anni di esperienza e la vasta gamma di fili è la scelta per il meglio!", img: IMG_MONOFILI, btn: 'Scopri i monofili', slug: 'line', imgLeft: false, imgFit: 'contain' },
  { title: 'Accessori\nda pesca', text: 'Linea di foderi che garantiscono il massimo della protezione alle vostre canne Falcon.', img: IMG_ACCESSORI, btn: 'Scopri gli accessori', slug: 'tools', imgLeft: true, imgFit: 'contain' },
];

export default function CategorieProdotti() {
  return (
    <>
      <style>{`
        .cp-hero { position: relative; height: 60vh; min-height: 480px; overflow: hidden; background: #000; display: flex; flex-direction: column; }
        .cp-hero-bg { position: absolute; inset: 0; object-fit: cover; width: 100%; height: 100%; opacity: 0.7; }
        .cp-hero-overlay { position: absolute; inset: 0; background: linear-gradient(to bottom, rgba(0,0,0,0.3), #000); }
        .cp-hero-content { position: relative; z-index: 10; padding: 140px 138px 60px; flex: 1; display: flex; flex-direction: column; }
        .cp-hero-inner { display: flex; flex-direction: row; align-items: stretch; gap: 22px; }
        .cp-hero-line { width: 2px; background: #d71921; flex-shrink: 0; }
        .cp-hero-text { display: flex; flex-direction: column; justify-content: flex-start; gap: 58px; flex: 1; }
        .cp-hero-title { font-family: 'Alumni Sans',sans-serif; font-weight: 500; font-size: 80px; line-height: 68px; color: #fff; margin: 0; white-space: pre-line; }
        .cp-hero-sub { font-family: 'Roboto',sans-serif; font-weight: 300; font-size: 19px; color: #fff; line-height: 1.6; max-width: 480px; margin: 0; }
        .cp-strip { background: #000; height: 60px; border-bottom: 1px solid #222; }
        .cp-cat { background: #000; position: relative; overflow: hidden; min-height: 560px; border-bottom: 1px solid #1a1a1a; display: flex; align-items: center; }
        .cp-cat-img { position: absolute; left: 0; top: 0; width: 100%; height: 130%; object-fit: cover; object-position: center center; transition: transform 0.4s; }
        .cp-cat:hover .cp-cat-img { transform: scale(1.04); }
        .cp-cat-cover-r { position: absolute; inset: 0; background: #000; z-index: 1; clip-path: polygon(calc(65% - 8px) 0%, 100% 0%, 100% 100%, calc(52% - 8px) 100%); }
        .cp-cat-line-r { position: absolute; inset: 0; background: #d71921; z-index: 2; pointer-events: none; clip-path: polygon(calc(65% - 8px) 0%, calc(65% + 8px) 0%, calc(52% + 8px) 100%, calc(52% - 8px) 100%); }
        .cp-cat-cover-l { position: absolute; inset: 0; background: #000; z-index: 1; clip-path: polygon(0 0, calc(35% + 8px) 0, calc(48% + 8px) 100%, 0 100%); }
        .cp-cat-line-l { position: absolute; inset: 0; background: #d71921; z-index: 2; pointer-events: none; clip-path: polygon(calc(35% - 8px) 0%, calc(35% + 8px) 0%, calc(48% + 8px) 100%, calc(48% - 8px) 100%); }
        .cp-cat-content { position: relative; z-index: 3; padding: 80px 70px; display: flex; flex-direction: column; justify-content: center; width: 38%; }
        .cp-cat-content-r { margin-left: auto; }
        .cp-cat-content-l { margin-right: auto; }
        .cp-cat-title { font-family: 'Alumni Sans',sans-serif; font-weight: 500; font-size: 68px; line-height: 60px; color: #fff; margin-bottom: 20px; white-space: pre-line; }
        .cp-cat-text { font-family: 'Roboto',sans-serif; font-weight: 300; font-size: 17px; color: rgba(255,255,255,0.8); line-height: 1.7; margin-bottom: 32px; max-width: 460px; }
        .cp-cat-btn { display: inline-block; background: #d71921; color: #fff; font-family: 'Alumni Sans',sans-serif; font-weight: 600; font-size: 19px; padding: 12px 26px; cursor: pointer; border: none; align-self: flex-start; transition: opacity 0.2s; }
        .cp-cat-btn:hover { opacity: 0.85; }

        @media (max-width: 1400px) {
          .cp-cat-content { padding: 60px 50px; }
          .cp-cat-title { font-size: 56px; line-height: 50px; }
        }
        @media (max-width: 1300px) {
          .cp-hero-content { padding: 130px 80px 50px; }
          .cp-hero-title { font-size: 66px; line-height: 58px; }
          .cp-cat-content { padding: 50px 40px; }
          .cp-cat-title { font-size: 50px; line-height: 44px; }
        }
        @media (max-width: 1100px) {
          .cp-hero-content { padding: 120px 60px 50px; }
          .cp-hero-title { font-size: 58px; line-height: 52px; }
          .cp-hero-sub { font-size: 15px; }
          .cp-cat-content { padding: 36px 28px; }
          .cp-cat-title { font-size: 44px; line-height: 38px; }
          .cp-cat-text { font-size: 15px; }
        }
        .cp-cat-contain { min-height: auto; aspect-ratio: 1920 / 560; }
        .cp-cat-contain .cp-cat-img { object-fit: contain; height: 100%; object-position: left center; }

        @media (max-width: 900px) {
          .cp-hero { height: auto; min-height: 420px; }
          .cp-hero-content { padding: 110px 28px 40px; }
          .cp-hero-title { font-size: 48px; line-height: 42px; }
          .cp-cat { flex-direction: column; min-height: auto; }
          .cp-cat-img { position: relative; width: 100%; height: 260px; }
          .cp-cat-cover-r, .cp-cat-cover-l, .cp-cat-line-r, .cp-cat-line-l { display: none; }
          .cp-cat-content, .cp-cat-content-r, .cp-cat-content-l { width: 100%; padding: 40px 28px; margin: 0; }
          .cp-cat-title { font-size: 48px; line-height: 44px; }
          .cp-cat-contain { aspect-ratio: auto; }
          .cp-cat-contain .cp-cat-img { height: 220px; object-fit: cover; object-position: center center; }
        }
        @media (max-width: 500px) {
          .cp-hero-title { font-size: 38px; line-height: 34px; }
          .cp-cat-title { font-size: 36px; line-height: 34px; }
        }
      `}</style>

      <section className="cp-hero">
        <img src={IMG_HERO_BG} alt="" className="cp-hero-bg" />
        <div className="cp-hero-overlay" />
        <Navbar />
        <div className="cp-hero-content">
          <div className="cp-hero-inner">
            <div className="cp-hero-line" />
            <div className="cp-hero-text">
              <h1 className="cp-hero-title">Categorie<br />prodotti</h1>
              <p className="cp-hero-sub">Scopri la nostra selezione di prodotti per la pesca, pensata per soddisfare le esigenze di appassionati e professionisti. Dalle canne agli accessori, ogni articolo è scelto per garantire qualità, affidabilità e performance in ogni situazione.</p>
            </div>
          </div>
        </div>
      </section>

      <div className="cp-strip" />

      {CATS.map((cat) => (
        <section key={cat.slug} className={`cp-cat${cat.imgFit === 'contain' ? ' cp-cat-contain' : ''}`}>
          <img src={cat.img} alt={cat.title} className="cp-cat-img" />
          {cat.imgLeft ? (
            <>
              <div className="cp-cat-cover-r" />
              <div className="cp-cat-line-r" />
              <div className="cp-cat-content cp-cat-content-r">
                <h2 className="cp-cat-title">{cat.title}</h2>
                <p className="cp-cat-text">{cat.text}</p>
                <Link to={`/categoria/${cat.slug}`}><button className="cp-cat-btn">{cat.btn}</button></Link>
              </div>
            </>
          ) : (
            <>
              <div className="cp-cat-cover-l" />
              <div className="cp-cat-line-l" />
              <div className="cp-cat-content cp-cat-content-l">
                <h2 className="cp-cat-title">{cat.title}</h2>
                <p className="cp-cat-text">{cat.text}</p>
                <Link to={`/categoria/${cat.slug}`}><button className="cp-cat-btn">{cat.btn}</button></Link>
              </div>
            </>
          )}
        </section>
      ))}

      <Footer />
    </>
  );
}
